import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  createDiamondPointOrderRequest,
  createDiamondPointOrderSuccess,
  createDiamondPointOrderFailure,
  getDiamondPendingOrderRequest,
  getDiamondPendingOrderSuccess,
  getDiamondPendingOrderFailure,
  cancelDiamondPointOrderRequest,
  cancelDiamondPointOrderSuccess,
  cancelDiamondPointOrderFailure,
} from "./DiamondPointSlice";
import { toast } from "react-toastify";
import { getRedeemBalanceRequest } from "../Redeem/redeemSlice";

function* createDiamondPointOrderSaga(action) {
  try {
    console.log("action.payload", action.payload);
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/diamond-point/create-redeem-order`,
        action.payload
      )
    );

    if (response.data.success) {
      yield put(createDiamondPointOrderSuccess(response.data.data));
      toast.success("Redeem order created successfully!");
       if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
    } else {
      yield put(createDiamondPointOrderFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(createDiamondPointOrderFailure(error.message));
    toast.error("Something went wrong while redeeming points");
  }
}

function* getPendingOrderSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/diamond-point/get-pending-order`,
        action.payload
      )
    );

    if (response.data.success) {
      yield put(getDiamondPendingOrderSuccess(response.data.data));
    } else {
      yield put(getDiamondPendingOrderFailure(response.data.message));
    }
  } catch (error) {
    yield put(getDiamondPendingOrderFailure(error.message));
  }
}

function* cancelDiamondPointOrderSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/diamond-point/cancel-order`,
        action.payload
      )
    );

    if (response.data.success) {
      yield put(cancelDiamondPointOrderSuccess(response.data.data));
      toast.success(response.data.message);
      if (action.payload.onSuccess) {
        action.payload.onSuccess();
      }
    } else {
      yield put(cancelDiamondPointOrderFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(cancelDiamondPointOrderFailure(error.message));
    toast.error("Failed to cancel the pending order");
  }
}

export function* diamondPointSaga() {
  yield takeLatest(
    createDiamondPointOrderRequest.type,
    createDiamondPointOrderSaga
  );
  yield takeLatest(getDiamondPendingOrderRequest.type, getPendingOrderSaga);
  yield takeLatest(
    cancelDiamondPointOrderRequest.type,
    cancelDiamondPointOrderSaga
  );
}
